export function generateSearchId() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var radix = 36;
  // consists of a timed prefix appended with a random string
  return ((time.getUTCMinutes() * 100000000 + time.getUTCHours() * 1000000 + time.getUTCFullYear() - 2000) * 10000 + (time.getUTCMonth() + 1) * 100 + time.getUTCDate()).toString(radix) + Math.floor(Math.random() * 100000).toString(radix);
}